<template>
  <div class="step-column-mapping" data-testid="step-column-mapping__view">
    <div class="step-column-mapping__available-columns">
      <div class="step-column-mapping__section-subtitle">Map Columns:</div>
      <div class="step-column-mapping__section-title">Available columns in sample uploaded</div>
      <v-chip
        v-for="(colum, i) in localSelectColums"
        :key="i"
        draggable
        class="ma-1 cursor-drag"
        label
        text-color="primary"
        color="blue-grey lighten-5"
        @dragstart="startDrag($event, colum, i)"
        data-testid="step-column-mapping__draggable-chip"
      >
        <v-icon left>mdi-drag</v-icon>
        <span>{{ colum }}</span>
      </v-chip>
    </div>

    <div class="step-column-mapping__required-columns">
      <div class="step-column-mapping__section-title">Required columns</div>
      <v-checkbox
        label="Create Unmapped Columns"
        class="mt-0 mb-2"
        :ripple="false"
        dense
        hide-details
        v-model="createColumns"
        data-testid="step-column-mapping__create-unmapped-checkbox"
      ></v-checkbox>

      <div class="step-column-mapping__mapping-grid">
        <div
          v-for="(fileCol, i) in fileColums"
          :key="i"
          class="step-column-mapping__mapping-item"
        >
          <div class="step-column-mapping__mapping-pair">
            <v-chip label class="d-block" outlined color="primary" style="width: 100px;">
              <span>{{ fileCol.name }}</span>
            </v-chip>
            <div class="step-column-mapping__divider-bridge">
              <v-divider horizontal></v-divider>
            </div>
            <div
              :class="[
                'step-column-mapping__drop-zone',
                { 'step-column-mapping__drop-zone--filled': (twoDiArray[i] || [])[1] },
              ]"
              @drop="onDrop($event, fileCol.name, i)"
              @dragover.prevent
              @dragenter.prevent
            >
              <div class="step-column-mapping__drop-content">
                <v-icon left v-if="(twoDiArray[i] || [])[1]">mdi-drag</v-icon>
                <span v-html="(twoDiArray[i] || [])[1] || '&nbsp;'"></span>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="(twoDiArray[i] || [])[1]"
                  icon
                  small
                  @click="removeItem((twoDiArray[i] || [])[1], i)"
                  data-testid="step-column-mapping__remove-mapping-btn"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="step-column-mapping__user-mapping-section">
      <div class="step-column-mapping__section-title mt-4 mb-2">User Column Mapping</div>
    </div>

    <div
      v-for="(col, key) in tempuserColMapColumns"
      :key="key"
      class="step-column-mapping__user-mapping"
    >
      <v-row>
        <v-col cols="6" sm="3">
          <div>{{ col.text }}</div>
        </v-col>
        <v-col cols="6" sm="3">
          <lb-dropdown
            v-model="tempuserColMapColumns[key].value"
            :items="tempuserColMapColumns[key].dropdown_options"
            :multiselect="false"
            :value="col.value"
            width="10"
            @change="setUserColMapColumnsDropdownValues(key, col.value)"
            data-testid="step-column-mapping__user-col-dropdown"
          ></lb-dropdown>
        </v-col>
      </v-row>
    </div>

    <div class="step-column-mapping__actions">
      <v-btn color="primary" @click="onBack" data-testid="step-column-mapping__back-btn">
        <p>Back</p>
      </v-btn>
      <v-btn color="primary" @click="onNextStep" data-testid="step-column-mapping__next-btn">
        <p>Next Step</p>
      </v-btn>
    </div>
  </div>
</template>

<script>
const USER_COL_MAP_DEFAULTS = {
  company_code: {
    text: 'Company code/name (Combo code)',
    value: 'string1',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  related_party_code: {
    text: 'Related party code/name (Combo code)',
    value: 'string2',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  customer_code: {
    text: 'Customer code (FIFO)',
    value: 'string3',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  customer_name: {
    text: 'Customer name (FIFO)',
    value: 'string4',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  amounts: {
    text: 'Amount to display in the summary and reconciliation tab',
    value: 'amount1',
    dropdown_options: [
      'amount1','amount2','amount3','amount4','amount5','amount6','amount7','amount8','amount9',
    ],
  },
  vendor_code: {
    text: 'Vendor code (FIFO)',
    value: '',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  vendor_name: {
    text: 'Vendor name (FIFO)',
    value: '',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  summary_combo_code: {
    text: 'Summary combo code, and this column should be split',
    value: '',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  invoice_date: {
    text: 'Invoice date',
    value: 'date1',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
  collection_date: {
    text: 'Collection date',
    value: 'date2',
    dropdown_options: [
      'string1','string2','string3','string4','string5','string6','string7','string8','string9','string10','string11','date1','date2','date3',
    ],
  },
};

export default {
  name: 'StepColumnMapping',
  props: {
    selectColums: {
      type: Array,
      required: true,
      default: () => [],
    },
    fileColums: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      localSelectColums: [...this.selectColums],
      twoDiArray: [],
      twoItem: null,
      createColumns: false,
      tempuserColMapColumns: JSON.parse(JSON.stringify(USER_COL_MAP_DEFAULTS)),
      userColMapColumns: JSON.parse(JSON.stringify(USER_COL_MAP_DEFAULTS)),
    };
  },
  created() {
    if (this.fileColums.length > 0) {
      this.arrayCreat();
    }
  },
  watch: {
    selectColums(val) {
      this.localSelectColums = [...val];
    },
    fileColums: {
      handler(val) {
        if (val && val.length > 0 && this.twoDiArray.length === 0) {
          this.arrayCreat();
        }
      },
      immediate: false,
    },
  },
  methods: {
    startDrag(evt, item) {
      this.twoItem = item;
      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
    },
    onDrop(evt, list, index) {
      if (this.twoDiArray[index]) {
        let oldArr = this.twoDiArray[index];
        if (oldArr.length === 2) {
          this.localSelectColums.push(oldArr[1]);
        }
        this.$set(this.twoDiArray, index, [oldArr[0], this.twoItem]);
      }
      const indexItem = this.localSelectColums.indexOf(this.twoItem);
      if (indexItem > -1) {
        this.localSelectColums.splice(indexItem, 1);
      }
    },
    arrayCreat() {
      this.twoDiArray = [];
      for (const i of this.fileColums) {
        this.twoDiArray.push([i.name]);
      }
    },
    removeItem(item, i) {
      this.localSelectColums.push(item);
      if (this.twoDiArray[i]) {
        this.$set(this.twoDiArray, i, [this.twoDiArray[i][0]]);
      }
    },
    onBack() {
      this.twoDiArray = [];
      this.$emit('back');
    },
    onNextStep() {
      const matchornot = this.twoDiArray.some((subArray) => subArray.length === 2);
      const unMapedColumc = [];
      const ignoredColumns = [];

      if (this.createColumns) {
        for (let j = 0; j < this.twoDiArray.length; j++) {
          if (this.twoDiArray[j].length === 1) {
            unMapedColumc.push(this.twoDiArray[j][0]);
          }
        }
      } else {
        for (let j = 0; j < this.twoDiArray.length; j++) {
          if (this.twoDiArray[j].length === 1) {
            ignoredColumns.push(this.twoDiArray[j][0]);
          }
        }
      }

      const mapedColumns = [];
      for (let k = 0; k < this.twoDiArray.length; k++) {
        if (this.twoDiArray[k].length === 2) {
          mapedColumns.push(this.twoDiArray[k]);
        }
      }

      const userMappedColumns = [];
      let index = 0;
      Object.keys(this.tempuserColMapColumns).forEach((key) => {
        if (this.tempuserColMapColumns[key].value && this.tempuserColMapColumns[key].value !== '') {
          userMappedColumns[index] = [];
          userMappedColumns[index].push(this.tempuserColMapColumns[key].value);
          userMappedColumns[index].push(this.tempuserColMapColumns[key].text);
          index++;
        }
      });

      if (matchornot) {
        this.$emit('next', {
          twoDiArray: this.twoDiArray,
          mapedColumns,
          unMapedColumc,
          ignoredColumns,
          createColumns: this.createColumns,
          userMappedColumns,
          selectColums: this.localSelectColums,
        });
      } else {
        this.$store.commit('sbError', 'At least one column must be mapped');
      }
    },
    setUserColMapColumnsDropdownValues(key, value) {
      if (value !== null && value !== '') {
        Object.keys(this.tempuserColMapColumns).forEach((itemKey) => {
          if (itemKey !== key) {
            this.tempuserColMapColumns[itemKey].dropdown_options =
              this.tempuserColMapColumns[itemKey]?.dropdown_options.filter((opt) => opt !== value);
          }
          this.userColMapColumns[key].value = value || '';
        });
      } else {
        if (this.userColMapColumns[key]?.value !== null && this.userColMapColumns[key]?.value !== '') {
          Object.keys(this.tempuserColMapColumns).forEach((item) => {
            if (
              item !== key &&
              this.userColMapColumns[item].dropdown_options.indexOf(this.userColMapColumns[key]?.value) !== -1
            ) {
              this.tempuserColMapColumns[item].dropdown_options = [
                ...this.tempuserColMapColumns[item].dropdown_options,
                ...[this.userColMapColumns[key]?.value],
              ];
            }
          });
          this.userColMapColumns[key].value = '';
        }
      }
    },
  },
  beforeDestroy() {
    this.twoDiArray = [];
    this.localSelectColums = [];
  },
};
</script>

<style lang="scss" scoped>
@import './StepColumnMapping.scss';
</style>
